<template>
  <div class="messaging-setting">
    <div class="title-header">
      <p>MESSAGING</p>
    </div>
    <div class="container-fluid">
        <input type="checkbox" checked="checked" />
        <span class="checkmark mt-0"></span>
      <label class="ml-2">
        Send a copy of all messaged to my email account.
      </label>
      
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.messaging-setting {
  .title-header {
    color: #58595b;
    font-size: 24px;
    font-weight: 600;
  }
  .container-fluid {
    position: relative;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container-fluid input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .container-fluid:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container-fluid input:checked ~ .checkmark {
    background-color: #51b72d;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container-fluid input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container-fluid .checkmark:after {
    left: 5px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}
</style>